
import {map} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RecordLink } from './record-link';
import { Apollo } from 'apollo-angular';

const linkNewRecordMutation = require('./gql/link-new-record.mutation.gql');
const linkExistingRecordMutation = require('./gql/link-existing-record.mutation.gql');
const updateRecordLinkMutation = require('./gql/update-record-link.mutation.gql');
const deleteRecordLinkMutation = require('./gql/delete-record-link.mutation.gql');

/**
 * Service to manage record links
 */
@Injectable()
export class RecordLinkService {

  constructor(private apollo: Apollo) { }

  linkNewRecord(dossier_id: string, link: RecordLink): Observable<RecordLink> {
    return this.apollo
      .mutate({
        mutation: linkNewRecordMutation,
        variables: {
          input: link.toLinkNewRecordInput(dossier_id)
        }
      }).pipe(
      map(result => new RecordLink(result.data['linkNewRecord'])));
  }

  linkExistingRecord(dossier_id: string, record_id: string, link: RecordLink): Observable<RecordLink> {
    return this.apollo
      .mutate({
        mutation: linkExistingRecordMutation,
        variables: {
          input: link.toLinkExistingRecordInput(dossier_id, record_id)
        }
      }).pipe(
      map(result => new RecordLink(result.data['linkExistingRecord'])));
  }

  update(id: string, link: RecordLink): Observable<RecordLink> {
    return this.apollo
      .mutate({
        mutation: updateRecordLinkMutation,
        variables: {
          id,
          input: link.toUpdateRecordLinkInput()
        }
      }).pipe(
      map(result => new RecordLink(result.data['updateRecordLink'])));
  }

  delete(id: string): Observable<string> {
    return this.apollo
      .mutate({
        mutation: deleteRecordLinkMutation,
        variables: {
          id
        }
      }).pipe(
      map(result => result.data['deleteRecordLink']));
  }
}